<div role="dialog" aria-label="Add your insurance" aria-modal="true">
  <div class="modal-body">
    <div class="pt-3 pb-2 px-3 px-sm-5">
      <div class="text-center mb-4">
        <img
          src="/assets/images/icons/pencil.svg"
          class="scribe-consent-modal-icon"
          data-cy="scribe-consent-modal-icon"
        />
        <om-scribe-consent-description
          [headerLevel]="4"
          [headerClasses]="'mt-3 mb-4'"
          [bodyClasses]="'mb-5'"
        ></om-scribe-consent-description>
        <button
          type="button"
          class="btn btn-primary btn-lg w-75 rounded-pill mb-3"
          data-cy="scribe-consent-modal-allow-btn"
          (click)="handleSelection(true)"
          >Allow</button
        >
        <br />
        <button class="btn btn-link" data-cy="scribe-consent-modal-deny-btn" (click)="handleSelection(false)"
          >Not at this time</button
        >
      </div>
    </div>
  </div>
</div>
